'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import { lang, tr } from '../../utils/helpers';

const activities = {
  settings: {},

  bindActions() {
    $('[name="make_donation"]').on('change', function (e) {
      if (e.target.value == 1) {
        $('#make-donations').show();
      } else {
        $('#make-donations').hide();
        $('[name="donation_qtd"]').val('');
        $('[name="donation_description"]').val('');
      }
    });
  },

  validation() {
    $('#form').on('submit', function (e) {
      if (!$('[name="activities[]"]:checked').length) {
        Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_check_activity, 'error');
        e.preventDefault();
      }

      if ($('[name="make_donation"]:checked').val() == 1) {
        if (!$('[name="donation_qtd"]').val().length || !$('[name="donation_description"]').val().length) {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_donations_quantity, 'error');
          e.preventDefault();
        }
      }
    });
  },

  init() {
    _this.bindActions();
    _this.validation();
  },
};

const _this = activities,
  s = _this.settings;

export default activities;
